import { useTranslation } from 'react-i18next'
import { css } from 'styled-components'

import { TokenizedAgentIcon, Tooltip } from '@blade/ui-kit'

import { PairElementContainer } from './pair-element-container'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  size?: number
} & ClassNameProps

export const PairTokenizedAgentBadge: React.FC<Props> = ({ size = 14 }) => {
  const { t } = useTranslation()
  return (
    <Tooltip content={t('pair.tokenized-agent.tooltip')}>
      <PairElementContainer>
        <TokenizedAgentIcon
          css={css`
            position: relative;
            pointer-events: auto;
          `}
          color="var(--success-9)"
          size={size}
        />
      </PairElementContainer>
    </Tooltip>
  )
}
